import { useEffect } from "react";
import { useGlobalSearchParams } from "expo-router";

import { api } from "~/utils/api";
import { IconPaymentError } from "~/component/feature/paywall/icons/icon-payment-error";
import { PaymentInfoScreen } from "~/component/feature/paywall/payment-info-screen";

const PaymentCancelPage = () => {
  const { ph_link_id } = useGlobalSearchParams<{ ph_link_id?: string }>();
  const { mutateAsync, isSuccess, isLoading } =
    api.payments.markManualStatus.useMutation();

  useEffect(() => {
    if (ph_link_id && !isSuccess && !isLoading) {
      void mutateAsync({ id: ph_link_id, type: "cancel" }).then(
        ({ status }) => {
          console.log("current status", status);
        },
      );
    }
  }, [ph_link_id, isSuccess, mutateAsync, isLoading]);

  return (
    <PaymentInfoScreen
      title={"Не вдалося здійснити оплату"}
      text={
        "Платіж не був завершений. Спробуйте ще раз або скористайтеся іншим способом оплати."
      }
      icon={<IconPaymentError />}
    />
  );
};

export default PaymentCancelPage;
